/*
 * Copyright (c) 2024 Ask Sage, Inc. All rights reserved.
 * This software is the confidential and proprietary information of Ask Sage, Inc.
 * You shall not disclose such confidential information and shall use it only in
 * accordance with the terms of the license agreement you entered into with Ask Sage, Inc.
 * THIS SOFTWARE IS PROVIDED "AS IS" AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 * INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 * FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL ASK SAGE, INC.
 * OR ITS CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
 * EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT
 * OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
 * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT,
 * STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
 * OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 * You may not use this software except in compliance with the License.
 * You may not modify, reverse engineer, or redistribute this software.
 */
import React, { useState, useEffect, useRef } from 'react';
import SideMenu from '../Chat/SideMenu'
import { ChatBox } from '../Chat/ChatBox'
import FilePopup from '../Popups/FilePopup.js'
import EditChat from '../Chat/Components/EditChat'
import AddDatasetPopup from '../Popups/AddDatasetPopup.js'
import ShareChat from '../Chat/Components/ShareChat'
import PersonaList from '../Personas/PersonaList.js'
import { getWithExpiry, getBotSettingItem, isBotLoggedIn, updateChatTitle, getChats, createChat, updateChat, deleteChat, getName, logout, getToken, getUser, setWithExpiry } from '../AuthService.js'
import { parseToolCalls, parseMessage, getTokenWindowR, isCUICapableR, getModelInfoR, getTokenizerR, proposeModelCount, canvas_allowed_models } from '../Utils/GenAI_helper.js'
import * as default_data from '../config.js'
import { v4 as uuidv4 } from "uuid";
import Modal from 'react-modal';
import { urlify, strip, unEscapeHTML, escapeHTML } from '../Utils/text_functions.js'
import { validateFile, removeMetadata } from '../Utils/file_functions.js'
import * as log from 'loglevel'
import { FileManagementDialog } from '../Popups/FileManagement/FileManagementDialog.js';
import { Box, IconButton, Stack, useMediaQuery, useTheme } from '@mui/material';
import { useUserSettings } from '../Contexts/UserPreferenceContext.js';
import { Navbar } from '../Chat/Navbar.js';
import { FiMenu } from 'react-icons/fi';
import { checkMode, scrollToBottom, trimChatHistoryByCount } from '../Utils/chatHelpers.js';
import CodeRenderer from './CodeRenderer.js'
import { getBannerColor } from '../Utils/classification_helper.js';

const CodeCanvas = ({ currentDatasetMode }) => {
    const [prevCommand, setPrevCommand] = useState([]);
    const [commandCount, setCommandCount] = useState(0);
    const [keyCount, setKeyCount] = useState(0);
    const [sideBarOpen, setSideBarOpen] = useState(false);
    const [hideSideBar, setHideSideBar] = useState(false);

    const [currentMode, setCurrentMode] = useState("advanced");
    const [chatInput, setChatInput] = useState("simple");
    const [currentModel, setCurrentModel] = useState("gpt");
    const [firstname, setName] = useState("");

    const [code, setCode] = useState('');
    const [history, setHistory] = useState([]); // Track history of changes
    const [currentHistoryIndex, setCurrentHistoryIndex] = useState(0); // Track the current index in history
    const [language, setLanguage] = useState('javascript');

    const resetRenderer = (cur_code='', cur_language='javascript', reset_history=true) => {
      setLanguage(cur_language);      
      setCode(cur_code)

      if(reset_history) {
        setCurrentHistoryIndex(0);
        setHistory([cur_code]);
      }
    };

    const [tokens_count, setTokensCount] = useState(0);

    const [loadingText, setLoadingText] = useState("Getting things ready...");    

    const [paid, setPaid] = useState(false);
    const [hasStripeID, sethasStripeID] = useState(false);
    const [cur_user, setUser] = useState(null);
    const [CACAuth, setCACAuth] = useState(false);
    const [CUIAuth, setCUIAuth] = useState(false);
    
    const [temperature, setTemperature] = useState(0.0);    
    const [live, setLive] = useState(0);    

    const [file, setCurrentFile] = useState(null);    

    const [currentChatIndex, setcurrentIndex] = useState(0);
    const [currentChats, setcurrentChats] = useState([]);
    const [chatButton, setchatButton] = useState([]);

    const [chatLog, setRChatLog] = useState([]);
    var latest_chatlog = [];

    const [isLoading, setIsLoading] = useState(false);

    const inputEditRef = useRef(null);
    const [modalIsEditOpen, setIsEditOpen] = React.useState(false);
    const [newEditName, setNewEditName] = React.useState("");
    const [currentEditKey, setCurrentEditKey] = React.useState("");

    const [triggerFilePopup, setTriggerFilePopup] = useState(0);
    const [triggerDatasetPopup, setTriggerDatasetPopup] = useState(0);
    const [triggerFilesPopup, setTriggerFilesPopup] = useState(false);

    const inputShareRef = useRef(null);
    const [modalIsShareOpen, setIsShareOpen] = React.useState(false);
    const [newShareEmail, setNewShareEmail] = React.useState("");
    const [currentShareKey, setCurrentShareKey] = React.useState("");
    const [currentShareName, setCurrentShareName] = React.useState("");
    const [errorShareMessage, setErrorShareMessage] = useState('');
    const [successShareMessage, setSuccessShareMessage] = useState('');
    const [isShareButtonDisabled, setIsShareButtonDisabled] = useState(false);
    
    const [personas, setPersonas] = useState([]);
    const [current_persona, setCurrentPersona] = useState(1);

    const [datasets, setDatasets] = useState([]);
    const [datasetPermissions, setDatasetPermissions] = useState([]);
    const [datasetEditOnly, setDatasetEditOnly] = useState([]);
    const [secrets, setSecrets] = useState([]);
    const [current_dataset, setCurrentDataset] = useState([{value: 'all', label: 'All'}]);

    const [triggerPersonaList, setTriggerPersonaList] = useState(0);

    const [loaded, setLoaded] = useState(false);
    var loaded_static = false;

    const showSubscribeBanner = (paid != true && default_data.default_customer_tenant !== true) || (cur_user && cur_user.plan_type && cur_user.plan_type === 'trial')

    const {state, dispatch} = useUserSettings();

    const theme = useTheme();

    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    function onMarkdownChange(value) {
      setCode(value);

      // update chatLog with new code changed
      var newChatLog = [...chatLog];
      for (var i = newChatLog.length - 1; i >= 0; i--) {
        if(newChatLog[i].user === "gpt") {
          newChatLog[i].code = value;

          var new_data = parseToolCalls(newChatLog[i], value)
          if(new_data !== null) {
            newChatLog[i] = new_data;
          }
          break;
        }
      }
      latest_chatlog = newChatLog;
      setChatLogAndSave(latest_chatlog, currentChatIndex, false)      
    }

    function extractCodeBlocks(markdown) {
      const regex = /```(\w+)\s*([\s\S]*?)```/g;
      const blocks = [];
      let match;
  
      while ((match = regex.exec(markdown)) !== null) {
        const [, language, code] = match;
        blocks.push({
          language,
          code: code !== null && code !== undefined ? code : '',
        });
      }
  
      if (blocks.length === 0) {
        blocks.push({
          language: 'javascript',
          code: markdown !== null && markdown !== undefined ? markdown : '',
        });
      }

      if(blocks.length > 0) { 
        return blocks[0];
      }
      return null;
    }

    function setChatLog(value) {
      latest_chatlog = value;
      return setRChatLog(value);
    }

    function showCopyData() {
      setTriggerFilesPopup(true);
    }

    function showPersonaList() {
      setTriggerPersonaList(1);
    }

    function showSimpleIngest() {
      setTriggerFilePopup(1);
    }

    function showAddDataset() {
      setTriggerDatasetPopup(1);
    }

    function closeEditModal() {
      setIsEditOpen(false);
    }

    async function handleEditSubmit(e){
      e.preventDefault();  

      var new_name = newEditName;
      var key = currentEditKey;

      if(key == '') {
        return;
      }
  
      var newButton = [...chatButton];
      const curButton = newButton.find(a => a.key === key.toString());
      if(curButton != null) {
        curButton.content = new_name
        setchatButton(newButton);

        await updateChatTitle(key.toString(), new_name);

        setIsEditOpen(false)
      }      
    }
  
    function editClick(e) {
      var target = isDescendantType('button', e.target);
      if(target === null) {
        return;
      }
      var key = target.dataset.key;
      if(key === null || key === undefined) {
        return;
      }
      key = key.toString();
  
      e.stopPropagation();
    
      const curButton = chatButton.find(a => a.key === key.toString());
      if(curButton != null) {
        setIsEditOpen(true)
        setNewEditName(curButton.content);
        setCurrentEditKey(key.toString())    
      }
    }

    /* Modal for Share Chat */
  
    function afterOpenShareModal() {
      // references are now sync'd and can be accessed.
    }
  
    function closeShareModal() {
      setIsShareOpen(false);
    }

    async function handleShareSubmit(e){
      e.preventDefault();  

      var new_email = newShareEmail;
      var key = currentShareKey;

      setErrorShareMessage('');
      setSuccessShareMessage('');

      if(key == '') {
        return;
      }
  
      const curButton = chatButton.find(a => a.key === key.toString());
      if(curButton != null) {
        var token = getToken()
        if(token === false) {
          setErrorShareMessage('Please login again.');
          return;
        }
    
        var user = getUser()
    
        if(user === false || user == null) {
            window.location = '/login';
        }

        setIsShareButtonDisabled(true)
      
        fetch(default_data.default_user_service_url_no_cac + '/copy-chat', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-access-tokens': `${token}`
          },        
          body: JSON.stringify({
            chat_id: key,
            email: new_email
          })
        })
          .then(response => {
            if (response.ok) {
              return response.json();
            }
            throw new Error('An error occurred while getting data.');
          })
          .then(data => {
            if(data.status != 200) {
                // display error
                if(data.status == 401) {
                  setErrorShareMessage('Please check that this email is valid.');
                }
                else if(data.status == 400) {
                  setErrorShareMessage('Internal error, please contact our customer support.');
                }
                else if(data.status == 410 || data.status == 411) {
                  setErrorShareMessage('This email is not from your organization.');
                }
                else {
                  setErrorShareMessage('Internal error, please contact our customer support.');
                }
                setIsShareButtonDisabled(false)
                return;
            }
            data = data.response;
            setIsShareButtonDisabled(false)
            setSuccessShareMessage('Success, the chat has been shared.');
            setTimeout(() => {
              setIsShareOpen(false)
            }, 15000);
          })
          .catch(error => {
            setIsShareButtonDisabled(false)
            setErrorShareMessage('Internal error, please contact our customer support.');
            console.log(error);
          });
      }    
    }

    function shareClick(e) {
      var target = isDescendantType('button', e.target);
      if(target === null) {
        return;
      }
      var key = target.dataset.key;
      if(key === null || key === undefined) {
        return;
      }
            
      setSuccessShareMessage('');
      setErrorShareMessage('');
      setIsShareOpen(true)
      setIsShareButtonDisabled(false)
      key = key.toString();
  
      e.stopPropagation();
    
      const curButton = chatButton.find(a => a.key === key.toString());
      if(curButton != null) {
        setCurrentShareName(curButton.content);
        setCurrentShareKey(key.toString())    
      }
    }

    function handleFileChange(event) {
      if (!validateFile(event.target.files[0])) {
        alert('Invalid file type. Please upload a valid file type.');
        return;
      }
      setCurrentFile(event.target.files[0]);
      event.target.value = null;
    }

    function handleAudio(blob, chatInput, setChatInput) {
      // Send the Blob to the API
      if (validateFile(blob)) {
        var token = getToken();
        if(token === false) {
          return;
        }
  
        setIsLoading(true);
        setLoadingText('Please wait, loading...');
  
        const formData = new FormData();
        formData.append('file', blob, 'audio.mp4'); // Add the Blob to the form data
        formData.append('strategy', 'auto');
  
        try {
          fetch(default_data.default_chat_service_url_files + '/file', {
            method: 'POST',
            headers: {
              'x-access-tokens': `${token}`,
              'Connection': 'keep-alive' // Add this line
            },        
            body: formData,
            timeout: 1200000 // 20 minutes in milliseconds
          })
          .then(response => {
            if (response.ok) {
              return response.json();
            }
            throw new Error('An error occurred while getting data.');
          })
          .then(data => {
            var ret = 'Internal error, please contact customer support with more information about your file'
    
            if(data['status'] == '200') {
              if(typeof data['ret'] === 'object') {
                if('text' in data['ret']) {
                  ret = removeMetadata(data['ret'].text);
                }
                else {
                  ret = 'Internal error, please contact customer support with more information about your file [2]'
                }
              }
              else {
                ret = removeMetadata(data['ret'])
              }
            }
            else if(data['response'] === 'No file too large') {
              ret = 'File too large, please contact customer support with more information about your file'
            }           
            else if(data['response'] === 'Virus detected in file') {
              ret = 'Virus detected in file, please contact customer support with more information about your file'
            }           
            else if(data['response'] === 'File type not allowed') {
              ret = 'File type not allowed, please contact customer support with more information about your file'
            }
            if(chatInput.length > 0) {
              setChatInput(chatInput + '\n' + ret)
            }
            else {
              setChatInput(ret)
            }
            setIsLoading(false);  
        })
        .catch(error => {
          setIsLoading(false);
          console.log(error);
        });  
        }
          catch (error) {
          setIsLoading(false);
          console.log(error)
        }
      }
    }
  
    function loadPersonas() {
      var token = getToken()
      if(token === false) {
          logout()        
          return;
      }
    
      fetch(default_data.default_chat_service_url + '/get-personas', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-access-tokens': `${token}`
        },        
        body: JSON.stringify({
        })
      })
        .then(response => {
          if (response.ok) {
            return response.json();
          }
          throw new Error('An error occurred while getting data.');
        })
        .then(data => {
          var res = data.response;
          if(data != null && data.status == '200') {            
            res.sort((a, b) => {
              const nameA = a['name'].toUpperCase();
              const nameB = b['name'].toUpperCase();
              if (nameA < nameB) {
                return -1;
              }
              if (nameA > nameB) {
                return 1;
              }
              return 0;
            });
            setPersonas(res)
          }
          else if(data != null && data.status == '400') {
            if(data.response.indexOf('Token is invalid') > -1) {
              logout()
            }
          }            
        })
        .catch(error => {
          console.log(error);
        });
    }  

    function loadDatasets() {
      var token = getToken()
      if(token === false) {
          logout()
          return;
      }
    
      fetch(default_data.default_user_service_url_no_cac + '/get-datasets-with-permissions', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-access-tokens': `${token}`
        },        
        body: JSON.stringify({
        })
      })
        .then(response => {
          if (response.ok) {
            return response.json();
          }
          throw new Error('An error occurred while getting data.');
        })
        .then(data => {
          if(data != null && data.status == '200') {            
            var res = data.response;

            var names = res.map(item => item.dataset);

            names.sort((a, b) => {
              const nameA = a.toUpperCase();
              const nameB = b.toUpperCase();
              if (nameA < nameB) {
                return -1;
              }
              if (nameA > nameB) {
                return 1;
              }
              return 0;
            });
            setDatasets(names);
            setDatasetPermissions(res);

            var edit_only = res.filter(item => item.permissions === 'edit' || item.permissions === 'owner' || item.permissions === 'admin');
            var edit_only_names = edit_only.map(item => item.dataset);

            setDatasetEditOnly(edit_only_names);
          }
        })
        .catch(error => {
          console.log(error);
        });
    }  

    function loadSecrets() {
      var token = getToken()
      if(token === false) {
          logout()
          return;
      }
    
      fetch(default_data.default_chat_service_url + '/get-secrets', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-access-tokens': `${token}`
        },        
        body: JSON.stringify({
        })
      })
        .then(response => {
          if (response.ok) {
            return response.json();
          }
          throw new Error('An error occurred while getting data.');
        })
        .then(data => {
          var res = data.response;
          if(data != null && data.status == '200' && res != null) {            
            res.sort((a, b) => {
              const nameA = a.toUpperCase();
              const nameB = b.toUpperCase();
              if (nameA < nameB) {
                return -1;
              }
              if (nameA > nameB) {
                return 1;
              }
              return 0;
            });
            setSecrets(res)
          }
        })
        .catch(error => {
          console.log(error);
        });
    }  

    async function loadChats() {
      setIsLoading(true);
      setLoadingText('Getting things ready...');
    
      var chats = await getChats()
      if (chats === null) {
        setcurrentChats([]);
        setchatButton([]);
        setIsLoading(false);
        return;
      }
    
      for (const element of chats.chats) {
        for (const sub_element of element.content) {
          if (sub_element.message_orig !== undefined && sub_element.message_orig !== null && sub_element.message_orig !== '') {
            var parsed_message = await parseMessage(random_element, unEscapeHTML(sub_element.message_orig));
            sub_element.message = parsed_message['message'];
            sub_element.images = parsed_message['images'];
          }
          var ret_parse_tools = parseToolCalls(sub_element)
          if(ret_parse_tools !== null) {
            sub_element.message = ret_parse_tools['message'];
            sub_element.code = ret_parse_tools['code'];
          }
          if (sub_element.message !== undefined && sub_element.message !== null && sub_element.message.indexOf('<convert_code>') !== -1) {
            sub_element.message = loadPendingCode(sub_element.message);
          }
        }
      }
      
      setcurrentChats(chats.chats);
      setchatButton(chats.buttons);

      // loop through chats to find a chat that is not code
      var found = false;
      for (const element of chats.chats) {
        if(checkMode(chats.chats, element.id, 'code')) {
          changeChat(element.id.toString(), chats.chats);
          found = true;
          break;
        }
      }

      if(chats.chats.length === 0 || found === false) {
        newChat()
      }
      setIsLoading(false);
    }
    
    function voteDown(uuid) {
      var token = getToken()
      if(token === false) {
        return;
      }
    
      fetch(default_data.default_chat_service_url + '/vote-down', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-access-tokens': `${token}`
        },        
        body: JSON.stringify({
          uuid: uuid
        })
      })
        .then(response => {
          if (response.ok) {
            return response.json();
          }
          throw new Error('An error occurred while getting data.');
        })
        .then(data => {
          if(data != null && data.status != 200) {            
            console.log(data)
          }
        })
        .catch(error => {
          console.log(error);
        });
    }  

    function getTokenizer(string) {

      setTokensCount(0)
      var token = getToken()
      if(token === false) {
        return ;
      }

      if (string == null || string == '') {
        return;
      }
    
      var embedding_model = 'openai_gpt';
      try {
        fetch(default_data.default_chat_service_url + '/tokenizer', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-access-tokens': `${token}`
          },        
          body: JSON.stringify({
            content: string,
            model: embedding_model
          })
        })
          .then(response => {
            if (response.ok) {
              return response.json();
            }
            throw new Error('An error occurred while getting data.');
          })
          .then(data => {
            if(data != null && data.status != 200) {            
              console.log(data)
            }
            else {
              var cur_tokens = parseInt(data.response);
              setTokensCount(cur_tokens)
            }
          })
          .catch(error => {
          });
      }
      catch {
        setTokensCount(0)
      }
    }  
    
    useEffect(() => {
        if(loaded || loaded_static) {
          return;
        }
      
        setLoaded(true)
        loaded_static = true;

        if(getWithExpiry('loss-pass') === true) {
          window.location = '/update?action=force_password';
          return;
        }

        if(getWithExpiry('currentMode') !== null && getWithExpiry('currentMode') === 'simple') {
          setCurrentMode('simple');
        }

        loadChats()

        loadPersonas()
        setInterval(loadPersonas, 10 * 60 * 1000);

        loadDatasets()
        loadSecrets()
        var user = getUser()
        if(isBotLoggedIn()) {
          if(getBotSettingItem('force_new_chat') === true) {         
            clearChat()
          }
        }                

        setPaid(user.paid)
        if(user.stripe_customer_id != null && user.stripe_customer_id != '') {
          sethasStripeID(true)
        }
        else {
          sethasStripeID(false)
        }

        var model_first = state.defaultModel
        // check if model_first is in canvas_allowed_models
        if(!canvas_allowed_models.includes(model_first)) {
          // check if default_data.default_allowed_models has one of the canvas_allowed_models
          if(default_data.default_allowed_models !== undefined && default_data.default_allowed_models.length > 0) {
            // loop through default_data.default_allowed_models and check if it is in canvas_allowed_models if so, set model_first to it and break
            for (var i = 0; i < default_data.default_allowed_models.length; i++) {
              if(canvas_allowed_models.includes(default_data.default_allowed_models[i])) {
                model_first = default_data.default_allowed_models[i]
                break
              }
            }
          }
        }

        // if model_first is not in canvas_allowed_models, console error
        if(!canvas_allowed_models.includes(model_first)) {
          log.error('CodeCanvas: ' + model_first + ' not in canvas_allowed_models')
        }
        setCurrentModel(model_first)

        setUser(user)

        setCUIAuth(false)
        if(user.cac_auth && (user.cac_auth === 'true' || user.cac_auth === true)) {
          setCACAuth(true)
          setCUIAuth(true)
        } 
        else {  
          setCACAuth(false) 
          setCUIAuth(false)
        }

        if(user.is_cui_mfa_authorized && user.is_cui_mfa_authorized === true && user.mfa_auth && (user.mfa_auth === 'true' || user.mfa_auth === true)) {
          setCUIAuth(true)
        } 
        
        setName(getName())
        loadChatLog()
        setCurrentPersona(state.defaultPersonality)
        // check local storage for chat input
        var chatInput = localStorage.getItem('chatInput');
        if (chatInput !== null) {
          setChatInput(chatInput);
        } else {
          localStorage.setItem('chatInput', 'simple');
        }
    }, [])
  
  useEffect(() => {
    setCurrentDataset(state.defaultDatasets)
  }, [state])

  // clear chats
  function clearChat(){
    setChatLogAndSave([{ user: "gpt", message: `Welcome, how can I help you?`, added_obj: null }], currentChatIndex, false);
    resetRenderer()
  }

  function newChat(){
    var new_index = uuidv4();
    setcurrentIndex(new_index)
    resetRenderer()
    setChatLogAndSave([{ user: "gpt", message: `Welcome, how can I help you?`, added_obj: null}], new_index, false)
  }
  var random_element = document.createElement('div');

  function loadChatLog() {
    if(currentChats.lenght === 0) {
      return setChatLog([{ user: "gpt", message: `Welcome, how can I help you?`, added_obj: null}])
    }
    else {
      const curChat = currentChats[0]
      if(curChat != null) {
        setcurrentIndex(curChat.id)
        setChatLog(curChat.content)
      }        
    }
  }

  function buttonClick(e) {    
    var key = e.target.dataset.key;
    if(key === undefined || key === null) {
      return;
    }
    key = key.toString();
    changeChat(key)
    setSideBarOpen(false)
  }

  function changeChat(key, curCurrentChats = null) {
    setcurrentIndex(key)

    if(curCurrentChats === null) {
      curCurrentChats = currentChats
    }
    const curChat = curCurrentChats.find(a => a.id === key);
    if(curChat != null) {
      setChatLog(curChat.content)
      // get last item in value array with last_item.user == "gpt"
      var found_code = false;
      for (var i = curChat.content.length - 1; i >= 0; i--) {
        if(curChat.content[i].user === "gpt") {
          if(curChat.content[i].code) {
            found_code = true;

            var code_block = extractCodeBlocks(curChat.content[i].code);
            if(code_block !== null) {
              resetRenderer(code_block.code, code_block.language)
              break;
            }
          }
        }
      }
      if(!found_code) {
        resetRenderer()
      }
    }
    else {
    }
  }

  function deleteClick(key) {
    key = key.toString();

    var count = currentChats.length;

    var newChats = currentChats.filter(a => a.id !== key)
    setcurrentChats(
      newChats
    );

    var newChatButton = chatButton.filter(a => a.key !== key)
    setchatButton(
      newChatButton
    );

    if(count === 1 || count === 0) {
       //newChat()
    }
    else {
      const curChat = currentChats.find(a => a.id !== key.toString());
      if(curChat != null) {
        changeChat(curChat.id.toString())
      }
    }
    if(!deleteChat(key)) {
      log.error('deleteChat: failed to delete chat ' + key)
    }
  }

  function setChatLogAndSave(chatLog, index=currentChatIndex, no_save=false) {
    setChatLog(chatLog)

    index = index.toString();

    var newChat = [...currentChats];
    const curChat = newChat.find(a => a.id === index);
    if(curChat != null) {
      curChat.content = chatLog; 
      setcurrentChats(newChat);
    }
    else {
      newChat = [ 
        { id: index, content: chatLog }, // and one new item at the end
        ...currentChats // that contains all the old items
      ]
      setcurrentChats(newChat);
    }

    var newButton = [...chatButton];
    const curButton = newButton.find(a => a.key === index);
    if(curButton != null) {      
      if (curButton.content.substring(0, 5) === "Chat ") {
        curButton.content = "Chat " + new Date().toLocaleString(); 
        setchatButton(newButton);
      }
      if(no_save === false) {
        if(!updateChat(index, curButton.content, chatLog)) {
          log.error('updateChat: failed to update chat ' + index)
        }
      }
    }
    else {
      var cur_title = "Chat " + new Date().toLocaleString();
      newButton = [ 
        { key: index, content: cur_title }, // and one new item at the end        
        ...chatButton // that contains all the old items        
      ]
      setchatButton(newButton);
      if(no_save === false) {
        if(!createChat(index, cur_title, chatLog)) {
          log.error('createChat: failed to create chat')
        }
      }
    }

    return chatLog
  }

  function addReferences(index_id, data, max_size=250) {

    if(data.references == null || data.references == '') {
      return;
    }
  
    var references = data.references 
    var references_array = []
    var references_descriptions = [] // New array to store descriptions
  
    // List of delimiters
    var delimiters = [
      ' - Video Description:',
      ' - Summary:',
      ' - Data:',
      ' - Article:',
      ' - Article Description:',
      ' - Content:',
      ' - Sage:'
    ];
    
    let refArray = references.split("\n");
    refArray.forEach((element) => {
      element = strip(element);
      var index = -1;
      var description = ''; // Variable to store description
      if(element != '') {
        // Iterate over delimiters
        for (let delimiter of delimiters) {
          if (element.indexOf(delimiter) !== -1) {
            index = element.indexOf(delimiter);
            description = element.substring(index + delimiter.length); // Store description
            element = element.substring(0, index);
            break; // Break the loop as soon as a delimiter is found
          }
        }
        if(index === -1) {
          if(element.length > max_size) {
            description = element;
            element = element.substring(0, max_size) + '...';
          }
          else {
            description = ''; // If no delimiter is found, description is empty
          }
        }
        references_array.push(urlify(escapeHTML(element)))
        references_descriptions.push(escapeHTML(description)); // Push description to array        
      }
    });
    
    var i = 1;
    var res_references = []
    var res_references_descriptions = []
    while(i <= 20) {
      if(data.message.indexOf('[' + i.toString() + ']') !== -1) {
        references_array.forEach((element) => {
          if(element.indexOf('[' + i.toString() + ']') !== -1) {
            res_references.push(element)
            res_references_descriptions.push(references_descriptions[references_array.indexOf(element)])
          }
        });
      }
      i++;
    }
    var found = findChatLogIndexAndUpdate(index_id, {references: res_references, references_descriptions: res_references_descriptions});
    if(found === true) {
      setChatLogAndSave(latest_chatlog, currentChatIndex, true)
    }    
  }

  function findChatLogIndexAndUpdate(index_id, array_values, append_message=false) {    
    var found_element = false;
    latest_chatlog.forEach((element) => {
      if(element['id'] == index_id) {
        for (var field in array_values) {
          if(append_message === true && field === 'message') {
            element[field] = element[field].replace(get_loading_message(), '');
            element[field] += array_values[field];    
          }
          else {
            element[field] = array_values[field];
          }
        }
        found_element = true;
      }
    });
    return found_element;
  }

  function analyzeUrls(index_id, text) {

    return new Promise(() => {
      var token = getToken()
      if(token === false) {
        return;
      }

      fetch(default_data.default_chat_service_url + '/analyze-all-links', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-access-tokens': `${token}`
        },        
        body: JSON.stringify({
          content: text
        })
      })
        .then(response => {
        if (response.ok) {
          return response.json();
        }
        throw new Error('An error occurred while getting data.');
      })
      .then(data => {
        if(data.status == 200) {
          var error_count = data.error_count
          var found = false;
          latest_chatlog.forEach((element) => {
            if(element['id'] == index_id) {
              element['analysis_failed'] = error_count;
              found = true;
            }
          });
          if(found) {
            setChatLogAndSave(latest_chatlog, currentChatIndex, true)
          }          
        }
      })
      .catch(error => {
      });
    });
  }  

  function detectDatasetCreated(index_id, inputString) {
    // Regular expression to match the pattern
    const regex = /Dataset [a-zA-Z0-9-]+ created!/;
  
    // Test the input string against the regular expression
    const isMatch = regex.test(inputString);
  
    if(isMatch) {
      loadDatasets()
    }
  }  

  function detectSecretCreated(index_id, inputString) {
    // Regular expression to match the pattern
    const regex = /Secret added successfully!/;
  
    // Test the input string against the regular expression
    const isMatch = regex.test(inputString);
  
    if(isMatch) {
      loadSecrets()
    }
  }  

  function cleanChatLogFromSecret() {
    // Regular expression pattern to match "/add-secret SECRET_NAME VALUE"
    const pattern = new RegExp("^/(add-secret|update-secret)\\s([a-zA-Z0-9]+)\\s([\\s\\S]+)$", "i");
  
    // Loop through each object in the chatLog array
    latest_chatlog.forEach((element) => {
      // Check if 'message' field matches the pattern
      if (pattern.test(element.message)) {
        // Replace the secret value with asterisks
        element.message = element.message.replace(pattern, (match, p1, p2, p3) => `/${p1} ${p2} *****`);
      }
  
      // Check if 'message_orig' field matches the pattern
      if (element.message_orig && pattern.test(element.message_orig)) {
        // Replace the secret value with asterisks
        element.message_orig = element.message_orig.replace(pattern, (match, p1, p2, p3) => `/${p1} ${p2} *****`);
      }
    });

    setChatLogAndSave(latest_chatlog, currentChatIndex, false)
    scrollToBottom();
    return latest_chatlog; // Return the updated chatLog array
  }
  
  function detectDatasetDeleted(index_id, inputString) {
    // Regular expression to match the pattern
    const regex = /Dataset [a-zA-Z0-9-]+ deleted!/;
  
    // Test the input string against the regular expression
    const isMatch = regex.test(inputString);
  
    if(isMatch) {
      loadDatasets()
    }
  }  

  async function getFollowUps(index_id){
    try {
      var token = getToken()
      if(token === null) {

        window.location = '/login';
      }

      var output = trimChatHistoryByCount(latest_chatlog, null, 10)

      var model = await proposeModelCount(2000, null, true)

      var error = false;
      const response = await fetch(default_data.default_chat_service_url + '/follow-up-questions', {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          'x-access-tokens': `${token}`        
        },
        body: JSON.stringify({
          message: output,
          model: model,
          dataset: getDatasetValues()
        })
        }).catch(err => {
          error = true
          console.log(err);
        });      
      if(error === true) {
      }
      else {
        const data = await response.json();
        if(data.status != 200) {
          if(data.response.indexOf('Token is invalid') !== -1) {
            return;
          }
          else {
            console.log(data)
            return;
          }
        }
        else {
          var follows = []
          var message = data.message;
          if(message.indexOf('<li>') !== -1) {
            // Loop through each <li> element and display its value            
            const li_regex = /<li>([\s\S]*?)<\/li>/g;
            const matches = message.match(li_regex);
            matches.forEach(li => {
              follows.push(li.replace('<li>', '').replace('</li>', ''));
            });
          }
          else if(message.indexOf('- ') !== -1) {
            const itemsArray = message.split("- ");
            itemsArray.forEach((element) => {
              element = strip(element);
              if(element != '') {
                follows.push(element)
              }
            });
          }
          else if(message.indexOf('1.') !== -1) {
            const itemsArray = message.split("\n")            
            itemsArray.forEach((element) => {
              element = strip(element);
              var numRegEx = /\d+\.\s/
              if(element != '' && numRegEx.test(element)) {
                var index = element.indexOf(' ');
                element = element.substring(index + 1)                
                follows.push(element)
              }
            });
          }
          else if(message.indexOf('?') !== -1) {            
            let itemsArray = message.split("\n");
            itemsArray.forEach((element) => {
              element = strip(element);
              if(element != '' && element.indexOf('?') !== -1) {
                follows.push(element)
              }
            });
          }

          var should_fail = false;
          follows.forEach((element) => {
            if(element.toLowerCase().indexOf('anything else you would like to know') !== -1) {
              should_fail = true;        
            }
            else if(element.toLowerCase().indexOf('can help you with') !== -1) {
              should_fail = true;        
            }
            else if(element.toLowerCase().indexOf('can i help you with') !== -1) {
              should_fail = true;        
            }
            else if(element.toLowerCase().indexOf('have any other question') !== -1) {
              should_fail = true;        
            }
            else if(element.toLowerCase().indexOf('would you like to know') !== -1) {
              should_fail = true;        
            }
            else if(element.toLowerCase().indexOf('i apologize') !== -1) {
              should_fail = true;        
            }
            else if(element.toLowerCase().indexOf('made a mistake') !== -1) {
              should_fail = true;        
            }
          });

          if(should_fail) {
            return;
          }
          var found = false;
          latest_chatlog.forEach((element) => {
            if(element['id'] == index_id) {
              element['follows'] = follows;
              found = true;
            }
          });
          if(found) {
            setChatLogAndSave(latest_chatlog, currentChatIndex, true)
            scrollToBottom();
          }            
        }
      }
      cleanChatLogFromSecret()
    }
    catch (error) {
      console.error(error);
    }
  }
  

const handleSelect = (event) => {
  setTemperature(event.target.value);
};

const handleModel = (event) => {
  if (typeof event.target.value === 'string') {
    setCurrentModel(event.target.value);
  }
};

const handlePersona = (event) => {
  if (Number.isInteger(event)) {
    setCurrentPersona(event);
  }
  else {
    setCurrentPersona(event.target.value);
  }
};

const handleDataset = (options) => {
  setCurrentDataset(options);
};

function getDatasetValues() {
  var values = current_dataset.map(option => option.value);
  if (values.includes('all')) {
    values = ['all']
  }
  else if (values.includes('none')) {
    values = ['none']
  }
  return values
}

const handleLive = (event) => {
  setLive(parseInt(event.target.value));
};

  function clickHandlerFollowUp(e, setChatInput) {
    var value = e.target.textContent;
    if(value != '') {
      submitPrompt(value, setChatInput)
      e.target.disabled = true;
    }
  }

  function clickHandlerCopy(e) {
    let el = e.target;
    while (el && el !== e.currentTarget && el.tagName !== "BUTTON") {
        el = el.parentNode;
    }
    var uuid = el.getAttribute('tag');
    if(uuid != '' && uuid != null) {
      var found = false;
      var content = '';
      chatLog.forEach((element) => {
        if(element['id'] == uuid) {
          content = unEscapeHTML(element['message_orig'])
          found = true;
        }
      });
      if(found) {
        el.classList.add('clicked');
        setTimeout(() => {
          el.classList.remove('clicked');
        }, 2000);
        navigator.clipboard.writeText(content);
      }          
      else {
        console.log('not found')
      }
    }
  }

  function clickHandlerEdit(id, message, setChatInput) {
    if(id != '' && id != null) {
      chatLog.forEach((element, index) => {
        if(element['id'] == id) {
          const truncatedChatLog = chatLog.slice(0, index);
          setChatInput(unEscapeHTML(message))
          setChatLogAndSave(truncatedChatLog, currentChatIndex, false);        
          return;
        }        
      });
    }
  }

  function clickHandlerDown(id) {
    if(id != '' && id != null) {
      var found = false;
      chatLog.forEach((element) => {
        if(element['id'] == id) {
          found = true;
        }
      });
      if(found) {
        voteDown(id)
      }          
      else {
        console.log('not found')
      }
    }
  }

  function clickHandlerDelete(item) {    
    if(item != '' && item != null) {
      // if item is string, search by ['id']
      if(typeof item === 'string') {
        // Filter the chatLog array to exclude the item with the specified uuid
        const updatedChatLog = chatLog.filter(element => element['id'] !== item);
        // Update the chatLog and save the updated list
        setChatLogAndSave(updatedChatLog, currentChatIndex, false);
      }
      else {
        const updatedChatLog = chatLog.filter(element => element !== item);
        setChatLogAndSave(updatedChatLog, currentChatIndex, false);
      }
    }
  }

  function getTokenWindow() {
    return getTokenWindowR(currentModel)
  }

  function isCUICapable() {
    return isCUICapableR(currentModel, live)
  }

  function get_loading_message() {
    return `<img class=${theme.palette.mode === 'dark' ? "spinner" : 'spinner-dark'} src="spinner.png" alt="Loading..."> I'm thinking, please wait...`;
  }

  async function getAutoName(prompt) {
    const token = getToken();
    const promptTemplate = `Create a concise and meaningful title for this chat based on the message: ${prompt}. If the message contains only numbers, respond with "Numbers Clarification". If the message contains only punctuation, respond with "Symbol Clarification". If the message is a request for code, describe what the code does without specifying the programming language. Provide only the title of the chat and nothing else.`;
    
    const formData = new FormData();
    formData.append('message', promptTemplate);
    formData.append('model', await proposeModelCount(await getTokenizerR(promptTemplate), null, true));
    formData.append('dataset', "none");
    formData.append('live', 0);
    formData.append('streaming', false);
  
    const response = await fetch(default_data.default_chat_service_url + '/query', {
      method: 'POST',
      headers: { 'x-access-tokens': token },
      body: formData,
      timeout: 1200000
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();

    if(data['status'] === 200) {
      let autoName = data.message;

      // check if autoName is a string
      if (typeof autoName === 'string') {
        // if length is less than 3, return null
        if (autoName.length < 3) {
          return null;
        }

        // if length is greater than 99, truncate text to 99
        return autoName.length > 99 ? autoName.substring(0, 99) : autoName;
      }
    }
    return null;
  }

  async function setChatAutoName(chatLogNew) {
    const firstMeMessage = chatLogNew.find(item => item.user === 'me');
    const filterMeMessages = chatLogNew.filter(item => item.user === 'me');
    const meMessageLength = filterMeMessages.length;

    if (state.autoNameChats && meMessageLength === 1) {
      const autoChatName = await getAutoName(firstMeMessage.message);
      if(autoChatName === null) {
        return;
      }
  
      setchatButton(prev => {
        const newButtons = [...prev];
        const chatButton = newButtons.find(button => button.key === currentChatIndex);
        if (chatButton) chatButton.content = autoChatName;
        return newButtons;
      });
  
      updateChat(currentChatIndex, autoChatName, chatLogNew);
    }
  }

  async function handleSubmit(e, chatInput, setChatInput){
    e.preventDefault();
    submitPrompt(chatInput, setChatInput)
  }  

  async function get_model_info() {
    return await getModelInfoR(currentModel, tokens_count, file)
  }

  async function handleResponseStream(chatLogNew, response) {
    
    const reader = response.body.getReader();
      
    const decoder = new TextDecoder('utf-8'); // Create a TextDecoder instance

    let bufferLeft = ''

    while(true) {
      const {value, done} = await reader.read();
      try {
        if(value === undefined) {
          // check if bufferLeft not empty and if starts and ends with {
          if (bufferLeft !== '' && bufferLeft.startsWith('{')) {
            try {
              var http_response = JSON.parse(bufferLeft);
              if(http_response.status !== 200 && http_response.status !== '200') {
                log.error(`/query_stream: Error 601: ${bufferLeft}`);
                setChatLogAndSave([...chatLogNew, { user: "gpt", message: `Error: please try again - the model servers are overloaded or your connection is unstable. If you are getting this error continuously, please try to start a new chat by typing /new or clicking on New Chat in the menu (top left) or reach out to us. [ERROR: 601]`, added_obj: null, type_auth: getTypeAuth() }], currentChatIndex, false);
              }
            }
            catch (error) {
              log.error(`/handleResponseStream: 2: ${error.message}`);
              log.error(`/handleResponseStream: 2: ${error.stack}`);
            }
          }
          return;
        }
        if (done) {
          if(bufferLeft !== '') {
            var ret2 = handleData(chatLogNew, bufferLeft);
            if(ret2 === null) {
              setChatLogAndSave([...chatLogNew, { user: "gpt", message: `Error: please try again - the model servers are overloaded or your connection is unstable. If you are getting this error continuously, please try to start a new chat by typing /new or clicking on New Chat in the menu (top left) or reach out to us. [ERROR: 101]`, added_obj: null, type_auth: getTypeAuth() }], currentChatIndex, false);
            }
            bufferLeft = ''
          }
          break;
        } 
        var tmp_text = decoder.decode(value); // Decode the Uint8Array into a string

        var cur_items_text = bufferLeft + tmp_text;

        if(cur_items_text.indexOf('@|@sep@|@') !== -1) {
          var cur_items = cur_items_text.split('@|@sep@|@'); // Split the chunk into lines
          for (const cur_item of cur_items) {
            if(cur_item !== '') {
              var err = handleData(chatLogNew, cur_item);
              if(err === null) {
                bufferLeft += cur_item;
              }
              else {
                bufferLeft = '';
              }
            }
          }  
        }
        else {
            bufferLeft = cur_items_text;
        }        
      }            
      catch(error) {
        log.error(`/query_stream: Error 1: ${error.message}`);
        log.error(`/query_stream: Error stack 2: ${error.stack}`);
      }
    }    
  }

  async function submitPrompt(input_obj, setChatInput) {
    try {
      var token = getToken()
      if(token === null) {
        logout()
        return;
      }

      var unescaped_input = input_obj;
      var escaped_input = escapeHTML(input_obj)
                  
      if(escaped_input == '') {
        return;
      }

      if(escaped_input.toLowerCase() === '/clear') {
        clearChat()
        setChatInput("");
        return;
      }
      if(escaped_input.toLowerCase() === '/new') {
        newChat()
        setChatInput("");
        return;
      }

      let prevCommandNew = [...prevCommand, unescaped_input]
      setPrevCommand(prevCommandNew);
      setCommandCount(commandCount + 1);

      var index_new_me_message = uuidv4();
      let chatLogNew = [...chatLog, { user: "me", id: index_new_me_message, file: file, message: escaped_input, added_obj: null, type_auth: getTypeAuth()} ]

      var model_info = await get_model_info()
      var new_model = canvas_allowed_models.includes(model_info.model) 
        ? model_info.model 
        : canvas_allowed_models[0];
      var history_count = model_info.history_count

      var output = trimChatHistoryByCount(chatLogNew, file, history_count)

      let chatLogNew2 = [...chatLogNew, { user: "gpt", message: get_loading_message(), added_obj: null} ]
      setChatInput("");
      setChatLogAndSave(chatLogNew2, currentChatIndex, true)

      scrollToBottom();      

      var forced_dataset = getDatasetValues()
      if(isBotLoggedIn() && getBotSettingItem('force_datasets') !== null) {
        forced_dataset = getBotSettingItem('force_datasets')        
      }
      var forced_persona = current_persona
      if(isBotLoggedIn() && getBotSettingItem('force_persona') !== null) {
        forced_persona = getBotSettingItem('force_persona')
      }
      var forced_live = live
      if(isBotLoggedIn() && getBotSettingItem('force_live') !== null) {
        forced_live = getBotSettingItem('force_live')
      }
      var forced_temperature = temperature
      if(isBotLoggedIn() && getBotSettingItem('force_temperature') !== null) {
        forced_temperature = getBotSettingItem('force_temperature')
      }

      const streamResults = async () => {  
        try {
          const formData = new FormData();
          formData.append('file', file);
          formData.append('message', JSON.stringify(output));
          formData.append('model', new_model);
          formData.append('temperature', forced_temperature);
          formData.append('persona', forced_persona);
          formData.append('dataset', forced_dataset);
          formData.append('live', forced_live);
          formData.append('streaming', true);
          formData.append('tools', JSON.stringify([
            {
              type: 'function',
              function: {
                name: 'respond_with_code_and_answer',
                description: 'Function must always be used to provide code and a textual answer',
                parameters: {
                  type: 'object',
                  properties: {
                    code: {
                      type: 'string',
                      description: 'Generated code'
                    },
                    answer: {
                      type: 'string',
                      description: 'Textual explanation or answer'
                    }
                  },
                  required: ['code', 'answer']
                }
              }
            }
          ]));
          var system_prompt = `You are a software developer with decades of experience, you write code that is not only efficient and reliable but also secure and meets the highest security standards such as the NIST Cybersecurity Framework and DoD Risk Management Framework. You must pay close attention to various types of injections, such as SQL injections and XSS injections, and ensure that code is free from vulnerabilities. Proper static and dynamic code security scanning and code review are essential to ensuring the security of the code. You are able to understand the requirements of a project and create code that meets those requirements. You must also be able to debug and troubleshoot any issues that arise. You always review your own code to ensure that it meets the highest security standards. Your purpose is to help government teams drive outcomes by providing them with secure and reliable software solutions that comply with specific security standards and protect against potential threats. `
          if(code !== null && code !== '') {
            system_prompt += `\n\nHere is the code you provided so far: ${code}`
          }
          system_prompt += `\n\nYour code response must only include the code, without example of usage, with indented code with detailed comments wrapped with \`\`\` elements with the proper code language parameter.\nYou must always use the tool function provided: respond_with_code_and_answer and respond by returning 'code' and 'answer' in valid JSON.`
          formData.append('system_prompt', system_prompt)

          const response = await fetch(default_data.default_chat_service_url + '/query', {
            method: 'POST',
            headers: {
              'x-access-tokens': `${token}`
            },
            body: formData,
            timeout: 1200000 // 20 minutes in milliseconds
          });
          
          if (!response.ok) {
            log.error(`/query_stream: Response Status: ${response.status}`);
            log.error(`/query_stream: Response Headers: ${JSON.stringify(response.headers)}`);        
            throw new Error(`HTTP error! status: ${response.status}`);
          }      
          try {
            if(file !== null && file.name) {
              if(file.name.toLowerCase().endsWith('.jpg') || file.name.toLowerCase().endsWith('.jpeg') || file.name.toLowerCase().endsWith('.png') || file.name.toLowerCase().endsWith('.csv') || file.name.toLowerCase().endsWith('.xlsx')) {
              }
              else {
                setCurrentFile(null);
              }
            }
            else {
              setCurrentFile(null);
            }              
          }            
          catch (error) {
          }          

          await handleResponseStream(chatLogNew, response)
        }
        catch (err) {
          if (!err.message) {
            setChatLogAndSave([...chatLogNew, { user: "gpt", message: `Error: please try again - the model servers are overloaded or your connection is unstable. If you are getting this error continuously, please try to start a new chat by typing /new or clicking on New Chat in the menu (top left) or reach out to us. [ERROR: 101]`, added_obj: null, type_auth: getTypeAuth() }], currentChatIndex, false);
          } else if (err.message.includes('Failed to fetch') && file !== null && file !== '') {
            setChatLogAndSave([...chatLogNew, { user: "gpt", message: `Error: your attached file might be open in another application (e.g., MS Word). Please close the file opened and try again.`, added_obj: null, type_auth: getTypeAuth() }], currentChatIndex, false);
          } else {
            log.error(`/query_stream: Error: ${err.message}`);
            log.error(`/query_stream: Fetch error stack: ${err.stack}`); // Log the error stack trace
            setChatLogAndSave([...chatLogNew, { user: "gpt", message: `Error: please try again - the model servers are overloaded or your connection is unstable. If you are getting this error continuously, please try to start a new chat by typing /new or clicking on New Chat in the menu (top left) or reach out to us. [ERROR: 202]`, added_obj: null, type_auth: getTypeAuth() }], currentChatIndex, false);
          }
        }
      }
  
      streamResults();
    }
    catch (error) {
      log.error(`/submitPrompt: 2: ${error.message}`);
      log.error(`/submitPrompt: 2: ${error.stack}`);
    }
  }

  async function handlePluginClick(plugin_name, plugin_values, prompt, setChatInput=undefined) {
    try {
      var token = getToken();
      if(token === null) {
        logout()
        return;
      }

      var unescaped_input = prompt;
      prompt = escapeHTML(prompt)

      let prevCommandNew = [...prevCommand, unescaped_input]
      setPrevCommand(prevCommandNew);
      setCommandCount(commandCount + 1);

      var index_new_me_message = uuidv4();
      let chatLogNew = [...chatLog, { user: "me", id: index_new_me_message, file: file, message: prompt, added_obj: null, type_auth: getTypeAuth()} ]

      var model_info = await get_model_info()
      var new_model = canvas_allowed_models.includes(model_info.model) 
        ? model_info.model 
        : canvas_allowed_models[0];

      let chatLogNew2 = [...chatLogNew, { user: "gpt", message: get_loading_message(), added_obj: null} ]
      if(setChatInput !== undefined) {
        setChatInput("");
      }
      setChatLogAndSave(chatLogNew2, currentChatIndex, true)

      var error = false;
      scrollToBottom();      

      const streamResults = async () => {  
        try {
          const formData = new FormData();
          formData.append('plugin_name', plugin_name);

          // look through items in plugin_values and replace undefined values by null
          for (var key in plugin_values) {
            if (plugin_values[key] === undefined) {
              plugin_values[key] = null;
            }
          }
          formData.append('plugin_values', JSON.stringify(plugin_values));
          formData.append('model', new_model);
          formData.append('live', live);

          const response = await fetch(default_data.default_chat_service_url + '/execute-plugin', {
            method: 'POST',
            headers: {
              'x-access-tokens': `${token}`        
            },
            body: formData,
            timeout: 1200000 // 20 minutes in milliseconds
          }).catch(err => {
            error = true
            if(!err.message){
              setChatLogAndSave([...chatLogNew, { user: "gpt", message: `Error: please try again - the model servers are overloaded or your connection is unstable. If you are getting this error continuously, please try to start a new chat by typing /new or clicking on New Chat in the menu (top left) or reach out to us.`, added_obj: null, type_auth: getTypeAuth() }], currentChatIndex, false);
            } else {
              setChatLogAndSave([...chatLogNew, { user: "gpt", message: `Error: please try again - the model servers are overloaded or your connection is unstable. If you are getting this error continuously, please try to start a new chat by typing /new or clicking on New Chat in the menu (top left) or reach out to us.`, added_obj: null, type_auth: getTypeAuth() }], currentChatIndex, false);
            }
          });      
          if(!error) {
            await handleResponseStream(chatLogNew, response)
          }
        }
        catch (error) {          
          setChatLogAndSave([...chatLogNew, { user: "gpt", message: `Error: please try again - the model servers are overloaded or your connection is unstable. If you are getting this error continuously, please try to start a new chat by typing /new or clicking on New Chat in the menu (top left) or reach out to us.`, added_obj: null, type_auth: getTypeAuth() }], currentChatIndex, false);
        }
      }
  
      streamResults();
    }
    catch (error) {
      log.error(`/handlePluginClick: 3: ${error.message}`);
      log.error(`/handlePluginClick: 3: ${error.stack}`);
    }
  }

  async function handleData(chatLogNew, ret, log_error=false) {
    var data = null;
    try {
      try {
        data = JSON.parse(ret);
      }
      catch(err) {
        if(log_error) {
          log.error(`/handleData: 3: ${ret}`);
          log.error(`/submitPrompt: ${err.message}`);
        }
        return null;
      }
      if(data === null) {
        return null;
      }
      var index_new_message = uuidv4();
      if(data.uuid != null && data.uuid != '') {
        index_new_message = data.uuid;
      }

      data.code = '';
      
      var ret_parse_tools = parseToolCalls(data)
      if(ret_parse_tools !== null) {
        data.message = ret_parse_tools['message'];
        if(ret_parse_tools['code'] !== undefined && ret_parse_tools['code'] !== null) {
          data.code = ret_parse_tools['code'];
          if(data.code !== '' && data.code !== null) {
            var code_block = extractCodeBlocks(data.code);
            if(code_block !== null) {
              resetRenderer(code_block.code, code_block.language, false)
            }
          }
        }
      }
      else {
        // debug should try to find code in there and separate???
      }

      if(data.message !== '' && data.message != null) {    
        if (Array.isArray(data.message)) {
          data.message = data.message.join('\n');
        }
        data.message = data.message.replace(' Source: ', "\n\nSource: ");
        data.message = data.message.replace(' Sources: ', "\n\nSources: ");
        data.message = data.message.replace(' Reference: ', "\n\nReference: ");
        data.message = data.message.replace(' References: ', "\n\nReferences: ");
        data.message = data.message.replace(' Reference 1: ', "\n\nReference 1: ");
        data.message = data.message.replace('.Reference: ', ".\n\nReference: ");
        data.message = data.message.replace('.References: ', ".\n\nReferences: ");
        data.message = data.message.replace('.Reference 1: ', ".\n\nReference 1: ");
        data.message = data.message.replace('Reference: 1.', "Reference:\n1.");
        data.message = data.message.replace('References: 1.', "References:\n1.");

        data.message_orig = data.message;

        var ret_parse = await parseMessage(random_element, data.message);
        data.message = ret_parse['message'];
        data.images = ret_parse['images'];

        data.added_obj = JSON.stringify(data.added_obj);

        if(data.type === 'yield') {
          data.message += "\n\n" + get_loading_message();
        }
        var chat_log_update_obj = {message: data.message, file: data.file, embedding_down: data.embedding_down, vectors_down: data.vectors_down, added_obj: data.added_obj, analysis_failed: false, type: data.type, images: data.images, code: data.code, tool_calls: data.tool_calls}
        if(data.type !== 'yield') {
          chat_log_update_obj['message_orig'] = data.message_orig
        }
        var cur_chat_log = findChatLogIndexAndUpdate(index_new_message, chat_log_update_obj, true)
        if(cur_chat_log === false) {
          setChatLogAndSave([...chatLogNew, { id: index_new_message, user: "gpt", message_orig: data.message_orig, message: data.message, embedding_down: data.embedding_down, vectors_down: data.vectors_down, added_obj: data.added_obj, analysis_failed: false, references:null, references_descriptions: null, type: data.type, type_auth: getTypeAuth(), images: data.images, code: data.code, tool_calls: data.tool_calls}], currentChatIndex, false)
        }
        else {
          setChatLogAndSave(latest_chatlog, currentChatIndex, false)
        }
        // debug find why object turns into string.
        if(data.type !== 'teach' && data.type !== 'yield') {
          if(data.images) {
          }
          else {
            addReferences(index_new_message, data)
            analyzeUrls(index_new_message, data.message)
            getFollowUps(index_new_message)
            setChatAutoName(latest_chatlog)
          }
        }
        else if(data.type === 'teach') {
          detectDatasetCreated(index_new_message, data.message)
          detectDatasetDeleted(index_new_message, data.message)
          detectSecretCreated(index_new_message, data.message)
          cleanChatLogFromSecret()
          setChatAutoName(latest_chatlog)
        }
      }
      else {
        setChatLogAndSave([...chatLogNew, { user: "gpt", message: `Sorry, please try a different prompt - No answer.`, added_obj: null, type_auth: getTypeAuth()} ], currentChatIndex, true)
      }        
      scrollToBottom();        
      return true;
    }
    catch (error) {
      log.error(`/handleData: 5: ${error.message}`);
      log.error(`/handleData: 5: ${error.stack}`);
      return null;
    }
  }

  function loadPendingCode(message) {
    var body = null;
  
    if(message.indexOf('</convert_code>') !== -1) {
      message = message.replace(/<br \/>/g, '\n');
  
      let parser = new DOMParser();
      const doc = parser.parseFromString(message, 'text/html');
  
      var codes = doc.getElementsByTagName('convert_code');
      [...codes].forEach((code) => {
        // horizontal scroll if too long
        var code_inner = code.innerHTML;
  
        random_element.innerHTML = code_inner;              
        code_inner = random_element.textContent;        
        code_inner = window.hljs.highlightAuto(code_inner).value
  
        // Create a new 'code' element and copy the contents of 'convert_code' into it
        const newCode = document.createElement('code');
        newCode.innerHTML = code_inner;
  
        const div = document.createElement('pre');
        div.className = "code_pre"
        const parent = code.parentElement;
  
        if(parent != null) {
          // Replace the 'convert_code' element with the new 'code' element
          parent.replaceChild(div, code);
          div.appendChild(newCode);  
          const copyButton = document.createElement('button');
          copyButton.className = "code_button";
          copyButton.innerText = 'Copy';  
          // Append the copy button to the <code> tag
          div.appendChild(copyButton);  
        }
        else {
        }
      });
      body = doc.getElementsByTagName('body');
      if(body.length != 0) {
        message = body[0].innerHTML;
      }
      else {
        message = doc.documentElement.innerHTML;
      }
      return message;            
    }
  }
  
  function getTypeAuth() {
    var type = 'non-cac';
    if(CACAuth === true) {
      type = 'cac';
    }
    return type;
  }

  function setChatLogAndSaveWithScroll(obj) {
    obj['type_auth'] = getTypeAuth()
    setChatLogAndSave([...chatLog, obj ])
    scrollToBottom()
  }

  const customShareStyles = {
    overlay: {
      position: 'fixed',
      zIndex: 1030,
      top: 0,
      left: 0,
      width: '100vw',
      borderRadius: '0.375rem',
      height: '100vh',
      overflowY: 'hidden',
      background: 'rgba(255, 255, 255, 0.75)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    content: {
      background: '#0e0d17',
      color: '#e9ecef',      
      width: '600px',
      height: '500px',
      margin: '10%',
      inset: 0,
      borderRadius: '30px',
      overflow: 'auto',
      position: 'relative',
      border: '1px solid #ccc'
    },
  };

  function switchMode() {
    if(currentMode === 'simple') {
      setCurrentMode('advanced')
      setWithExpiry('currentMode', 'advanced', 1000 * 60 * 60 * 24 * 365 * 10)
    }
    else {
      setCurrentMode('simple')
      setWithExpiry('currentMode', 'simple', 1000 * 60 * 60 * 24 * 365 * 10)
    }
  }

  const loading_styles = {
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      background: 'rgba(0, 0, 0, 0.9)', // Adjust the opacity as needed
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 9999, // Adjust the z-index as needed to ensure it appears above other elements
    },
    loadingText: {
      color: '#fff',
      fontSize: '24px',
    },
  };

  const copyChatToClipboard = (chatKey) => {
    const selectedChat = currentChats.find(chat => chat.id === chatKey)
    const messages = selectedChat.content.map(message => {
      var cur_message = message.message
      if(message.message_orig !== undefined && message.message_orig !== null && message.message_orig !== '') {
        cur_message = message.message_orig;
      }

      return `${message.user === 'gpt' ? 'Ask Sage' : 'Me'}: ${unEscapeHTML(cur_message)}\n\n`
    })
    const chatText = messages.join('')
    navigator.clipboard.writeText(chatText)
  }

  function isDescendantType(parentType, child) {
    if (child.tagName.toLowerCase() === parentType.toLowerCase()) {
      return child;
    }
    let node = child.parentNode;
    while (node !== null) {
      if (node.tagName.toLowerCase() === parentType.toLowerCase()) {
        return node;
      }
      node = node.parentNode;
    }
    return null;
  }

  Modal.setAppElement('#root');

  const getBannerHeight = () => {
    if(isMobile) {
      if (showSubscribeBanner) {
        return 'calc(100dvh - 100px)';
      }
      return 'calc(100dvh - 66px)';  
    }
    else {
      if (showSubscribeBanner) {
        return 'calc(100dvh - 50px)';
      }
      return 'calc(100dvh - 16px)';
    }
  }

  return (
  <Box 
    className="AppContainer" 
    sx={{
      backgroundColor: theme.palette.appBackground,
    }}
  >
    {
      isBotLoggedIn() && getBotSettingItem('hide_banner') === true ?
      '' :
      (CUIAuth === true) ?
      <div className={`header-message ${getBannerColor(CUIAuth)}`}>
        { default_data.default_banner_override != null && default_data.default_banner_override != '' ?
            default_data.default_banner_override : 'CUI'
        }
      </div>
      :
      <div className={`header-message ${getBannerColor(CUIAuth)}`}>
        { default_data.default_banner_override != null && default_data.default_banner_override != '' ?
            default_data.default_banner_override : 'UNCLASSIFIED'
        }
      </div>
    }
    {
      showSubscribeBanner && (
        <div className="header_subscribe">
          <a href="/payment">{default_data.default_subscribe_banner_text}</a>
        </div>
      )
    }
    <Stack 
      direction={ isMobile ? 'column' : 'row' }
      sx={{
        width: '100vw',
        height: getBannerHeight(), 
      }}
    >
      {isMobile && (
        <Stack direction={'row'} justifyContent={'space-between'}>
          <IconButton onClick={()=>{setSideBarOpen(true)}} >
            <FiMenu size={24} />
          </IconButton>
          <div>
            <a href="/dashboard"><img src="logo-menu.png" alt="Ask Sage"/></a>
          </div>
          <Box width={50}></Box>
        </Stack>
      )}
      
      {!isMobile && <Navbar/>}
      <div style={{display: 'flex', height: '100%', width:'100%'}} className={`${((paid != true && default_data.default_customer_tenant !== true) || (cur_user && cur_user.plan_type && cur_user.plan_type === 'trial')) ? 'longer' : ''} ${isBotLoggedIn() ? 'bot' : ''}`}>
        <EditChat
          inputEditRef={inputEditRef}
          newEditName={newEditName}
          setNewEditName={setNewEditName}
          modalIsEditOpen={modalIsEditOpen}
          closeEditModal={closeEditModal}
          handleEditSubmit={handleEditSubmit}
        />
        <ShareChat
          open={modalIsShareOpen}
          onClose={closeShareModal}
          isShareButtonDisabled={isShareButtonDisabled}
          inputShareRef={inputShareRef}
          successMessage={successShareMessage}
          errorMessage={errorShareMessage}
          chatName={currentShareName}
          setNewShareEmail={setNewShareEmail}
          handleSubmit={handleShareSubmit}
          newShareEmail={newShareEmail}
          currentShareKey={currentShareKey}
        />
        <PersonaList personas={personas} loadPersonas={loadPersonas} setTriggerPersonaList={setTriggerPersonaList} triggerPersonaList={triggerPersonaList} handlePersonaClick={handlePersona} />
        {
          isBotLoggedIn() && getBotSettingItem('hide_chat_history') === true ?
          ''
          :
          <SideMenu
            mode={'code'}
            currentChats={currentChats}
            chatButton={chatButton}
            buttonClick={buttonClick}
            newChat={newChat}
            currentChatIndex={currentChatIndex}
            deleteClick={deleteClick}
            editClick={editClick}
            shareClick={shareClick}
            clearChat={clearChat}
            setSideBarOpen={setSideBarOpen}
            sideBarOpen={sideBarOpen}
            copyChatToClipboard={copyChatToClipboard}
            hideSideBar={hideSideBar}
            setHideSideBar={setHideSideBar}
          />
        }
        <ChatBox
          mode='canvas'
          chatbox_class='chatbox-canvas'
          currentMode={currentMode}
          currentModel={currentModel}
          chatLog={chatLog} 
          cur_user={cur_user}
          handleSelect={handleSelect}
          handleModel={handleModel}
          showSimpleIngest={showSimpleIngest}
          showPersonaList={showPersonaList}
          showCopyData={showCopyData}
          showAddDataset={showAddDataset}
          live={live}
          paid={paid}
          file={file}
          setFile={setCurrentFile}
          personas={personas}
          current_persona={current_persona}
          handlePersona={handlePersona}
          datasets={datasets}
          datasetPermissions={datasetPermissions}
          current_dataset={current_dataset}
          handleDataset={handleDataset}
          handleLive={handleLive}
          temperature={temperature}
          clickHandlerFollowUp={clickHandlerFollowUp}
          clickHandlerCopy={clickHandlerCopy}
          clickHandlerDelete={clickHandlerDelete}
          clickHandlerDown={clickHandlerDown}
          clickHandlerEdit={clickHandlerEdit}
          handleAudio={handleAudio}
          tokens_count={tokens_count}
          getTokenWindow={getTokenWindow}
          isCUICapable={isCUICapable}
          handleFileChange={handleFileChange}
          handleSubmit={handleSubmit}
          getTokenizer={getTokenizer}
          prevCommand={prevCommand}
          secrets={secrets}
          setChatLogAndSaveWithScroll={setChatLogAndSaveWithScroll}
          setCurrentPersona={setCurrentPersona}
          handlePluginClick={handlePluginClick}
          chatInput={chatInput}
          setChatInputMode={setChatInput}
          hideSidebar={hideSideBar}
          hideModelSelect={true}
          singleFileOnly={true}
        />
        <div className="markdown-renderer-canvas">
        <CodeRenderer history={history} setHistory={setHistory} currentHistoryIndex={currentHistoryIndex} setCurrentHistoryIndex={setCurrentHistoryIndex} markdown={code} language={language} onMarkdownChange={onMarkdownChange} />
        </div>
      </div>
    </Stack>
    <FilePopup paid={paid} showAddDataset={showAddDataset} datasets={datasets} datasetPermissions={datasetPermissions} setTriggerFilePopup={setTriggerFilePopup} triggerFilePopup={triggerFilePopup} />
    {triggerFilesPopup && (
      <FileManagementDialog
        datasetNames={datasetEditOnly}
        datasetPermissions={datasetPermissions}
        setDatasets={setDatasets}
        loadDatasets={loadDatasets}
        setTriggerFilesPopup={setTriggerFilesPopup}
        triggerFilesPopup={triggerFilesPopup}
        triggerIngestPopup={showSimpleIngest}
        ingestPopup={triggerFilePopup}
      />
    )}
    <AddDatasetPopup loadDatasets={loadDatasets} setTriggerDatasetPopup={setTriggerDatasetPopup} triggerDatasetPopup={triggerDatasetPopup} />
    {/* Loading overlay */}
    {isLoading && (
      <div style={loading_styles.overlay}>
        <span style={loading_styles.loadingText}>{loadingText}</span>
      </div>
    )}
  </Box>
);
}

export default CodeCanvas;